import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { vuetifyDarkTheme, vuetifyLightTheme } from '@/theme/vuetifyPalette';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: { customProperties: true },
    themes: {
      light: vuetifyLightTheme,
      dark: vuetifyDarkTheme,
    },
  },
});
